import { useContext } from "react";

import { CoverTypeContext } from "@/app/components/cover-type/provider/cover-type.provider";
import FadeAnimation from "@/app/shared-components/animation/fade-animation";
import { useWizard } from "@/app/shared-providers/wizard-context-provider";

import { DescriptionSectionLayoutType } from "../../types/question-layout-types";
import TrustpilotHeader from "../truspilot-header";

function DescriptionSection({
  content,
  descriptionContentSpringRef,
  descriptionRef,
  isBackGroundImage,
}: Readonly<DescriptionSectionLayoutType>) {
  const coverTypeContext = useContext(CoverTypeContext);
  const { current } = useWizard();

  const showNewButtonsLayout = current.uiElementControls?.showNewButtonsLayout;
  const shouldShowTrustpilot =
    (!isBackGroundImage && coverTypeContext?.selectedAnswer !== 0) ||
    current.uiElementControls?.showdefaultDescriptionSection;

  return (
    <div
      className={`
      flex rounded-radius-xxl bg-dark-surface-accent-1-primary text-surface-neutral-option-2 h-full
      ${
        showNewButtonsLayout
          ? "flex-col-reverse md:flex-col"
          : "flex-col-reverse lg:flex-col"
      }
      ${isBackGroundImage ? "" : "lg:min-h-[632px]"}
    `}
      ref={descriptionRef}
    >
      {shouldShowTrustpilot && (
        <div
          className={`bg-transparent-overlay py-spacing-m ${
            showNewButtonsLayout
              ? "rounded-b-radius-xxl md:rounded-t-radius-xxl md:rounded-b-none lg:rounded-t-radius-xxl lg:rounded-b-none hidden md:flex w-full items-center gap-spacing-m px-spacing-m md:px-spacing-xl lg:px-spacing-xl"
              : "rounded-b-radius-xxl lg:rounded-t-radius-xxl lg:rounded-b-none hidden lg:flex justify-between px-spacing-m lg:px-spacing-xl"
          }`}
        >
          {/* Header Section */}
          <TrustpilotHeader />
        </div>
      )}

      {/* Bottom Section */}

      <FadeAnimation animationRef={descriptionContentSpringRef}>
        <div
          className={`
         flex flex-col items-center h-full
        ${
          isBackGroundImage
            ? ""
            : " pt-spacing-l pb-spacing-m md:pt-spacing-xxl md:pb-spacing-xxl lg:min-h-[632px]"
        }
        `}
        >
          {content}
        </div>
      </FadeAnimation>
    </div>
  );
}

export default DescriptionSection;
